import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export async function fetchWithAuth(url: string, options: RequestInit = {}): Promise<Response> {
  const response = await fetch(url, options);

  if (response.status === 401 && url.startsWith('/api/')) {
    console.log(`fetchWithAuth: Received 401 from internal API (${url}), user session expired.`);
    // Let Supabase's onAuthStateChange handle the signout automatically
    // No need for custom events since Supabase handles multi-tab auth state
    window.location.reload(); // Force a page reload to trigger auth check
    return new Response(JSON.stringify({ error: 'Session expired' }), {
      status: 401,
      headers: { 'Content-Type': 'application/json' },
    });
  }

  return response;
}
